// src/components/common/PortalFeatureCard.jsx

const PortalFeatureCard = ({
  title,
  description,
  imageSrc,
  onClick,
}) => {
  return (
    <div className="relative h-full pt-1 hover:z-20 focus-within:z-20">
      <button
        type="button"
        onClick={onClick}
        className="
          group
          relative isolate
          h-full w-full
          rounded-tl-[40px] rounded-br-[40px] bg-[#E6F0FC]
          p-4 pt-4
          text-left
          transition-all duration-300
          hover:-translate-y-1 hover:shadow-xl
          focus-visible:-translate-y-1 focus-visible:shadow-xl
          focus:outline-none
          focus-visible:ring-2 focus-visible:ring-[#0087FE] focus-visible:ring-offset-2
        "
      >
      {/* IMAGE — mockup đã có sẵn Union + logo ở góc trái */}
      <div className="overflow-hidden rounded-tr-[28px]  relative z-0">
        <img
          src={imageSrc}
          alt={title}
          className="
            w-full h-[340px] mobile:h-[300px]
            object-cover
            transition-transform duration-500
          "
        />
      </div>

      {/* DESCRIPTION */}
      <p className="text-[14px] font-medium leading-[1.6] text-[#343945] mb-2">
        {description}
      </p>

      {/* TITLE + ARROW (hover only) */}
      <div className="flex items-center justify-between mt-1">
        <span
          className="
            text-[24px] font-bold
            text-[#101624]
            transition-colors
            group-hover:text-[#0087FE]
            group-focus-visible:text-[#0087FE]
          "
        >
          {title}
        </span>

        {/* Arrow Button */}
        <span
          className="
            inline-flex items-center justify-center
            w-11 h-11 rounded-full
            bg-[#0087FE]
            text-white
            opacity-0 translate-x-2
            pointer-events-none
            transition-all duration-300
            group-hover:opacity-100 group-hover:translate-x-0
            group-focus-visible:opacity-100 group-focus-visible:translate-x-0
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </span>
      </div>
    </button>
    </div>
  );
};

export default PortalFeatureCard;
